import React, { useMemo, useCallback } from 'react'
import { useSelector, shallowEqual } from 'react-redux'
import { makeBranchIds } from '~data/selectors/collections'

import Lazy from '~co/virtual/lazy'
import Container from './container'

const keyExtractor = _id => _id

export default function Bookmarks(props) {
    const { spaceId = 0, search = '', full = false, ...etc } = props
    const getBranchIds = useMemo(() => makeBranchIds(), [])
    const singleIds = useMemo(() => [spaceId], [spaceId])

    const ids = useSelector(
        state => {
            const { nested_view_legacy } = state.config
            if (full || nested_view_legacy) return singleIds
            return getBranchIds(state, spaceId)
        },
        shallowEqual
    )

    const compact = ids.length > 1
    const renderSpace = useCallback(
        id => (
            <Container
                {...etc}
                search={search}
                full={full}
                spaceId={id}
                compact={compact}
            />
        ),
        [etc, search, full, compact]
    )

    if (ids.length <= 1) return renderSpace(ids[0])

    return (
        <div className={'ui-bookmarks'}>
            <Lazy
                data={ids}
                keyExtractor={keyExtractor}
                initialNumToRender={20}
                activateAfter={20}>
                {renderSpace}
            </Lazy>
        </div>
    )
}
